import { useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { useParameters } from '@web/utils/src';
import { InnerNavigation } from '@/components/InnerNavigation';
import { useReatailersQueryQuery } from '../FarmersHomePage/retailers.generated';

const DocumentsLayout = () => {
  const { retailerId } = useParameters<{ retailerId: string }>();
  const [{ data }] = useReatailersQueryQuery();

  const showInvoicesTab = useMemo(() => {
    if (!retailerId || !data?.retailers) return false;

    const retailer = data.retailers.find(
      (item) => item?.id.toString() === retailerId,
    );
    return retailer?.settings?.hideInvoices !== true;
  }, [retailerId, data]);

  return (
    <div className="flex min-h-100vh font-rg w-full">
      <div className="container">
        <InnerNavigation
          showInvoicesTab={showInvoicesTab}
          retailerId={retailerId}
        />
        <hr className="text-secondary-grey" />
        <Outlet />
      </div>
    </div>
  );
};

export default DocumentsLayout;
